import React from "react";

/**
 * Typographic logo for D. Welch Urethane Roofing LTD
 * Clean, industrial, two-color mark built with CSS.
 */
export const Logo = ({ className = "", compact = false }) => {
  return (
    <a
      href="#home"
      data-testid="site-logo"
      className={`inline-flex items-center gap-3 group ${className}`}
      aria-label="D. Welch Urethane Roofing — Home"
    >
      {/* Monogram */}
      <span
        className="relative inline-flex items-center justify-center w-10 h-10 shrink-0"
        aria-hidden="true"
      >
        <span className="absolute inset-0 bg-[#c41e3a]" />
        <span className="absolute inset-[3px] bg-[#1a1a1a]" />
        <span className="relative font-display font-black text-white text-lg tracking-tighter">
          DW
        </span>
      </span>

      {/* Wordmark */}
      {!compact && (
        <span className="flex flex-col leading-none whitespace-nowrap">
          <span className="font-display font-black text-white text-[15px] tracking-[0.02em] uppercase">
            D. Welch
          </span>
          <span className="font-mono-upper text-[10px] text-[#c41e3a] mt-1">
            Urethane Roofing
            <span className="text-white/40"> · LTD</span>
          </span>
        </span>
      )}
    </a>
  );
};

export default Logo;
